import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const AuthManager: FC = () => {
  const { isManager, isLoading } = useAuthContext();

  return <Middleware isLoading={isLoading}>{isManager ? <Outlet /> : <Navigate to={Routes.LOGIN} />}</Middleware>;
};

export default AuthManager;
